// Add class to body on scroll
import Swiper from 'swiper/bundle';

const swiper = new Swiper('.swiper-latest', {
    effect: 'fade',
    autoplay: {
        delay: 3000,
    },
    fadeEffect: {
        crossFade: true
    },
});

const brandingSwiper = new Swiper('.brandingSwiper', {
    slidesPerView: 5,
    spaceBetween: 32,
    speed: 1000,
    loop: true,
    lazy: true,
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },
    watchSlidesProgress: true,
    breakpoints: {
        "@0.00": {
            slidesPerView: 3,
            spaceBetween: 16,
        },
        "@0.60": {
            slidesPerView: 3,
        },
        "@1.00": {
            slidesPerView: 4,
        },
        "@1.50": {
            slidesPerView: 5,
        },
    },

});

if (jQuery(".referenceSwiper")[0]) {
    const referenceSwiper = new Swiper('.referenceSwiper', {
        slidesPerView: 2,
        spaceBetween: 32,
        speed: 2000,
        loop: true,
        lazy: true,
        autoplay: {
            delay: 4000,
            disableOnInteraction: true,
        },
        watchSlidesProgress: true,
        pagination: true,
        pagination: {
            el: ".referencePagination",
            clickable: true,
        },
        breakpoints: {
            "@0.00": {
                slidesPerView: 1,
                spaceBetween: 16,
            },
            "@0.60": {
                slidesPerView: 1,
            },
            "@1.00": {
                slidesPerView: 2,
            },
            "@1.50": {
                slidesPerView: 2,
            },
        },

    });
}

if (jQuery(".referenceSwiper")[0]) {
    var mySwiper = document.querySelector('.referenceSwiper').swiper
    jQuery(".referenceSwiper").mouseenter(function () {
        mySwiper.autoplay.stop();
    });

    jQuery(".referenceSwiper").mouseleave(function () {
        mySwiper.autoplay.start();
    });
}

function NavOnScroll() {
    jQuery(window).on('scroll', function () {
        var scroll = jQuery(window).scrollTop();
        if (scroll >= 100) {
            jQuery("body").addClass("scrolled");
        } else {
            jQuery("body").removeClass("scrolled");
        }
    });
}
NavOnScroll()

// Mobile menu toggle

function MobileMenu() {
    jQuery("body").on('click', '.menu-toggle', function () {
        jQuery('.menu-toggle').toggleClass('toggle-open');
        jQuery('.mobile-menu').toggleClass('mobile-menu-open');
    });

    jQuery("body").on('click', '.uzp__allfilters', function () {
        jQuery('.uzp__filters').toggleClass('is-open');
    });

    jQuery("body").on('click', '.mobile-menu .menu-item-has-children', function () {
        jQuery(this).find('ul.sub-menu').toggleClass('sub-menu-open');
        jQuery(this).toggleClass('item-is-open');
    });
}
MobileMenu()




function readMore() {

    jQuery("body").on('click', '.readMore', function () {
        var id = jQuery(this).attr('ReadMore');
        jQuery('.' + id).slideToggle(300).addClass('active');

        if (jQuery(this).html() === "Lees meer") {
            jQuery(this).html('Lees minder');
            jQuery(this).toggleClass('open');
        } else {
            jQuery(this).html('Lees meer');
            jQuery(this).toggleClass('open');
        }
    });
}
readMore()

function disabled() {
    jQuery("body").on('click', '.readMore', function () {
        var toggle = jQuery(this).parent().find('.readMore');
        jQuery(this).parent().find('.more').slideToggle(300);
        if (toggle.html() === "Lees meer") {
            toggle.html('Lees minder');
            toggle.toggleClass('open');
        } else {
            toggle.html('Lees meer');
            toggle.toggleClass('open');
        }
    });
}